import * as React from 'react';
import {TextField, css} from '@sail/ui';

// TODO: width is currently still broken when not using `&&`
export const Width = () => (
  <TextField label="Age" css={{width: css.value('42px')}} />
);
